import React, {useContext, useState} from 'react'
import { useEffect } from 'react';
import { convertColors } from '../../../../functions/Functions';
import {EditedContext} from '../../../../partials/Context'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faPencil} from'@fortawesome/free-solid-svg-icons';
import PhotoModal from './PhotoModal';

function Personal() {
    const [modal_show, setModalShow] = useState(false)
    const edited = useContext(EditedContext);
    const {edited_item, lawyer_data, changeBtn, input_value, setInputValue, setErrors} = edited || '';
    const [titles, setTitles] = useState([]);


    const {added_photo_url, user, title, year_started, entry_number} = lawyer_data || ''
    const {first_name} = user || ''
    const {name: title_name, color} = title || ''
    const {user: input_user} = input_value || ''
    const {first_name: input_first_name} = input_user || ''

    let options_list = [];

    useEffect(() => {
        fetch('/api/titles/').then(res => {
            res.json().then(data => {
                setTitles(data)
            })
        })
    }, [])


    if (titles) {
        titles.forEach(title => {
            const {name, id} = title || ''
            options_list.push(
                <option key={id} value={id}>{name}</option>
            )
        })
        options_list.unshift(
            <option value=""></option>
        )
    }


  return (
    <div id="personal" className="personal-data-section">
        <h3 className="title">Dane osobowe</h3>
        <div className="content">
            <div className="photo">
                <img src={added_photo_url ? added_photo_url : '../../../media/img/ghost.png'} alt="Zdjęcie profilowe prawnika" />
                <button id="change-btn" onClick={() => setModalShow(true)}>
                    <FontAwesomeIcon icon={faPencil} />
                    <span>Zmień</span>
                </button>
            </div>
            <div className="name">
                {edited_item === 'first_name' ? 
                    <input type="text" className="form-input" value={input_first_name} onChange={(e)=>setInputValue({user: {first_name: e.target.value}})}/>
                :
                <h3 id="name">{first_name}</h3>
                }
                {changeBtn('first_name')}
            </div>

            <div className="lawyer_title">
                {edited_item === 'lawyer_title' ?
                    <select name="title" id="title" onChange={(e) => {
                    setInputValue({title: {id: e.target.value ? e.target.value : ''}})}
                    }>
                        {options_list}
                    </select>
                    :
                    <span style={{color: convertColors(color)}}     id="lawyer-title">{title_name ? title_name : 'tytuł'}</ span>
                }
                {changeBtn('lawyer_title')}
            </div>
            <div className="start-date">
                {edited_item === 'year_started' ? 
                    <span>Od: <input type="text" className="form-input"  value={input_value.year_started} onChange={(e)=>setInputValue({year_started: e.target.value})}/>
                </span>
                    :
                    <span id="start-date">(od: {year_started ? year_started : 'rok rozpoczęcia praktyki'})</span>
                }
                {changeBtn('year_started')}
                
            </div>
            {title_name !== 'Notariusz' ?
            <div className="entry-number">
                {edited_item === 'entry_number' ?
                    <span>
                        Numer wpisu:
                        <input type="text" className="form-input" value={input_value.entry_number} onChange={(e)=>setInputValue({entry_number: e.target.value})}/>
                    </span>
                    :
                    <span id="entry_number">Numer wpisu: {entry_number ? entry_number: 'Nie podano'}</span>
                }
                {changeBtn('entry_number')}
            </div> : null}
        </div>
        <PhotoModal  setErrors={setErrors} show={modal_show} setShow={setModalShow}/>
    </div>
  )
}

export default Personal